import script from "./DeleteAccountPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteAccountPopup.vue?vue&type=script&setup=true&lang=ts"

import "./DeleteAccountPopup.vue?vue&type=style&index=0&id=d0542a6c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0542a6c"]])

export default __exports__